import React, { forwardRef, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getElementOffset } from '@huggg/bar-staff';
import { useScrollPosition, useWindowResize } from 'hooks';
import { Logo, useThemeContext } from '@huggg/react-components';
import styles from './menu.module.scss';

const shouldStick = (element) => {
  const offset = getElementOffset(element);
  const scrollY = window.scrollY;

  return scrollY > 0 && scrollY >= offset.top;
};

const Menu = forwardRef((props, ref) => {
  const localRef = useRef();
  const menuRef = ref || localRef;
  const position = useScrollPosition();
  const [isSticky, setIsSticky] = useState(false);

  const { name: theme } = useThemeContext();

  // TODO need a logo background color in the theme model,

  useWindowResize(() => {
    const parent = menuRef.current.parentNode;

    setIsSticky(shouldStick(parent));
  });

  useEffect(() => {
    const parent = menuRef.current.parentNode;
    const listener = () => setIsSticky(shouldStick(parent));

    window.addEventListener('scroll', listener);
    setIsSticky(shouldStick(parent));

    return () => window.removeEventListener('scroll', listener);
  }, [menuRef, position]);

  let backgroundColor = 'white';
  switch (theme) {
    case 'welfare':
      backgroundColor = '#4550a5';
      break;
    case 'default':
      backgroundColor = '#facbd7';
      break;
    default:
      backgroundColor = 'white';
      break;
  }

  return (
    <div className={styles.menu} ref={menuRef} data-testid="nav-container">
      <nav
        style={{ backgroundColor }}
        className={classnames(styles.nav, {
          [styles.isScrolled]: isSticky,
        })}
      >
        <Logo className={styles.logo} />
      </nav>
    </div>
  );
});

Menu.propTypes = {
  menuItems: PropTypes.shape({
    left: PropTypes.array,
    right: PropTypes.array.isRequired,
  }).isRequired,
};

export default React.memo(Menu);
